import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
} from '@element-plus/icons-vue'
import { useRoute,useRouter } from "vue-router";



export default /*#__PURE__*/_defineComponent({
  __name: 'Aside',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isCollapse = ref(true)
const handleOpen = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
  console.log(key, keyPath)
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(route).path,
    class: "el-menu-vertical-demo",
    onOpen: handleOpen,
    onClose: handleClose,
    router: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, { index: "/home/Initializebbar" }, {
        title: _withCtx(() => [
          _createTextVNode("初始化书签")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file-lines" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/home" }, {
        title: _withCtx(() => [
          _createTextVNode("所有书签")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-bookmark" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/home/TopMain" }, {
        title: _withCtx(() => [
          _createTextVNode("书签置顶栏")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-up-1-9" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})